function AppNavbar({
  brandMark = "\u{1F3C6}",
  brandName = "Global Chess Arena",
  tagline = "Team Competition Platform",
  primaryNavItems = [],
  secondaryNavItem = null,
  currentPage,
  onNavigate,
  signedIn = false,
}) {
  return (
    <header className="appNavbarShell">
      <nav className="appNavbar" aria-label="Primary">
        <button type="button" className="appNavbarBrand" onClick={() => onNavigate?.("home")}>
          <span className="appNavbarBrandMark" aria-hidden="true">{brandMark}</span>
          <span className="appNavbarBrandText">
            <strong>{brandName}</strong>
            <small>{tagline}</small>
          </span>
        </button>

        {signedIn ? (
          <div className="appNavbarActions">
            <div className="appNavbarLinks" role="navigation" aria-label="Sections">
              {primaryNavItems.map((item) => (
                <button
                  key={item.id}
                  type="button"
                  className={`appNavbarLink ${currentPage === item.id ? "isActive" : ""} ${item.isIconOnly ? "isIconOnly" : ""}`}
                  onClick={() => onNavigate?.(item.id)}
                  aria-current={currentPage === item.id ? "page" : undefined}
                  aria-label={item.navText || item.label}
                >
                  <span className="appNavbarLinkIcon" aria-hidden="true">{item.icon || ""}</span>
                  {!item.isIconOnly && <span>{item.navText || item.label}</span>}
                </button>
              ))}
            </div>

            {secondaryNavItem && (
              <>
                <span className="appNavbarDivider" aria-hidden="true" />
                <button
                  type="button"
                  className={`appNavbarProfileButton ${currentPage === secondaryNavItem.id ? "isActive" : ""}`}
                  onClick={() => onNavigate?.(secondaryNavItem.id)}
                  aria-current={currentPage === secondaryNavItem.id ? "page" : undefined}
                  aria-label={secondaryNavItem.navText || secondaryNavItem.label}
                >
                  <span className="appNavbarLinkIcon" aria-hidden="true">{secondaryNavItem.icon || ""}</span>
                  <span>{secondaryNavItem.navText || secondaryNavItem.label}</span>
                </button>
              </>
            )}
          </div>
        ) : null}
      </nav>
    </header>
  );
}

export default AppNavbar;
